import BaseElement from '@theme/base-element'
import '@theme/ui-dialog-toggle'
import { WithApiClientMixin } from '@theme/mixin-with-api-client'
import { WithModalDialog } from '@theme/mixin-with-modal-dialog'

// Component styles (was src/styles/component-dialog.css)
const styles = `
.dialog::backdrop {
  display: none;
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition-property: display,opacity,overlay;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 100ms;
  transition-duration: 300ms;
  transition-behavior: allow-discrete;
}

@media (prefers-reduced-motion: reduce) {
  .dialog::backdrop {
    transition-property: none;
  }
}

.dialog[open]::backdrop {
  display: block;
  opacity: 1;
  transition-delay: 0s;
}

@starting-style {
  .dialog[open]::backdrop {
    opacity: 0;
  }
}

.dialog {
  position: fixed;
  inset: 0px;
  margin: 0px;
  display: block;
  height: 100dvh;
  width: 100dvw;
  overflow: hidden;
  overscroll-behavior: contain;
  background-color: unset;
  opacity: 1;
  transition-property: visibility,opacity,display,overlay;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-behavior: allow-discrete;
}

@media (prefers-reduced-motion: reduce) {
  .dialog {
    transition-property: none;
  }
}

.dialog:modal {
  max-height: 100dvh;
  max-width: 100vw;
}

@media (min-width: 768px) {
  .dialog[type='modal'] {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.dialog:not([open]) {
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
  transition-delay: 500ms;
  transition-duration: 700ms;
}

.dialog:not([open])::backdrop {
  opacity: 0;
}

@starting-style {
  .dialog[open] {
    opacity: 0;
  }
}

.modal {
  height: 100%;
  width: 100%;
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  overflow-y: auto;
  overscroll-behavior: contain;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  opacity: 0;
  transition-property: opacity,transform,overlay;
  transition-delay: 0s;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@media (prefers-reduced-motion: reduce) {
  .modal {
    transition-property: none;
  }
}

@media (min-width: 768px) {
  .modal {
    height: auto;
    width: 83.333333%;
    --tw-translate-y: 4rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media (min-width: 1024px) {
  .modal {
    max-height: 100dvh;
    max-width: 42rem;
  }
}

.modal[size='modal-max'] {
  height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
  max-width: 100% !important;
}

.dialog[open] .modal {
  transform: none;
  opacity: 1;
  transition-delay: 100ms;
}

.drawer {
  position: fixed;
  right: 0px;
  height: 100%;
  width: 100%;
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  overflow-y: auto;
  overscroll-behavior: contain;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  transition-property: transform;
  transition-delay: 0s;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.drawer::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track);
  border-radius: var(--scrollbar-track-radius);
}

.drawer::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track));
}

.drawer::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track)));
}

.drawer::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: var(--scrollbar-thumb-radius);
}

.drawer::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb));
}

.drawer::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb)));
}

.drawer::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner);
  border-radius: var(--scrollbar-corner-radius);
}

.drawer::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner));
}

.drawer::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner)));
}

.drawer {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial);
}

.drawer::-webkit-scrollbar {
  display: block;
  width: 8px;
  height: 8px;
}

.drawer {
  --scrollbar-track: transparent;
  --scrollbar-thumb: #FDF1EE
;
}

@media (prefers-reduced-motion: reduce) {
  .drawer {
    transition-property: none;
  }
}

@media (min-width: 640px) {
  .drawer {
    max-width: 475px;
  }
}

.drawer[anchor='left'] {
  left: 0px;
  right: auto;
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dialog:not([open]) .drawer[anchor='right'] {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-delay: 0s;
}

.dialog:not([open]) .drawer[anchor='left'] {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-delay: 0s;
}

.dialog[open] .drawer {
  transform: none;
  transition-delay: 100ms;
}
`
import {
  Task,
  initialState,
  html,
  nothing,
  unsafeCSS,
  unsafeHTML,
} from '@theme/vendor-lit'

export class ModalDialog extends WithApiClientMixin(
  WithModalDialog(BaseElement)
) {
  constructor() {
    super(...arguments)

    this.type = 'modal'
    this.anchor = 'right'
    this.withoutTitle = false
    this.closeOnBackdropClick = false
    this.headerClasses = ''
    this.dialogClasses = ''
    this.closeIconSize = '24'
    this.closeIconPosition = 'right'

    this.#triggerElement = null

    this._loadURLContentTask = new Task(this, {
      task: async ([url], { signal }) => {
        if (!this.hasToLoadURL) {
          return initialState
        }
        const response = await this.$api.client.fetchClient(url, {
          method: 'GET',
          signal,
          headers: {
            'Content-Type': 'text/html',
          },
        })
        signal.throwIfAborted()
        return response
      },
      args: () => [this.url],
    })
  }
  static get properties() {
    return {
      open: { type: Boolean, reflect: true },
      type: { type: String },
      size: { type: String, reflect: true },
      anchor: { type: String },
      withoutTitle: {
        type: Boolean,
        reflect: true,
        attribute: 'without-title',
      },
      closeOnBackdropClick: {
        type: Boolean,
        attribute: 'close-on-backdrop-click',
      },
      headerClasses: { type: String, attribute: 'header-classes' },
      dialogClasses: { type: String, attribute: 'dialog-classes' },
      closeIconSize: { type: String, attribute: 'close-icon-size' },
      closeIconPosition: { type: String, attribute: 'close-icon-position' },
      url: { type: String, attribute: 'url' },
    }
  }

  static styles = [unsafeCSS(styles)]

  get dialog() {
    return this.updateComplete.then(
      () => this.renderRoot?.querySelector('dialog') ?? null
    )
  }

  get iframeOrVideo() {
    return (
      this.renderRoot ?? document.createDocumentFragment()
    ).querySelectorAll('iframe, video')
  }

  #triggerElement

  _handleBackdropClick(event) {
    if (!this.closeOnBackdropClick) {
      return
    }

    if (
      event.target instanceof HTMLElement &&
      event.target.tagName === 'DIALOG'
    ) {
      this.#handleClose()
    }
  }

  _handleGenericClick(event) {
    const target = event.target
    if (target.hasAttribute('close-modal')) {
      event.preventDefault()
      this.#handleClose()
    }

    if (target.closest('[close-modal]')) {
      event.preventDefault()
      this.#handleClose()
    }
  }

  _focusOnFirstElement() {
    try {
      setTimeout(async () => {
        const dialog = await this.dialog
        if (dialog) {
          const firstFocusableElement = dialog.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          )

          if (firstFocusableElement) {
            firstFocusableElement.focus()
          }
        }
      }, 300)
    } catch (error) {
      console.error('Error in _focusOnFirstElement', error)
    }
  }

  async show() {
    const dialog = await this.dialog
    if (dialog && !dialog.open) {
      this.#triggerElement = document.activeElement
      dialog.showModal()
      if (this.#triggerElement && this.#triggerElement !== document.body) {
        this.#triggerElement.blur()
        this._focusOnFirstElement()
      } else {
        dialog.focus()
      }
      this.open = true
    }
  }

  #handleClose() {
    this.closeModal()
  }

  async hide() {
    const dialog = await this.dialog

    if (dialog && dialog.open) {
      dialog.close()
      this.open = false
    }

    if (this.#triggerElement) {
      this.#triggerElement.focus()
    }
  }

  get hasToLoadURL() {
    const url = this.url
    return !(
      !url ||
      url === '#' ||
      url === 'about:blank' ||
      url === 'javascript:;' ||
      url === 'javascript:void(0)' ||
      url === ''
    )
  }

  get dialogContentHTML() {
    if (!this.hasToLoadURL) {
      return html`<slot @click=${this._handleGenericClick}></slot>`
    }

    return html`
      ${this._loadURLContentTask.render({
        pending: () =>
          html`<p class="caption animate-pulse p-md text-center">
            Loading...
          </p>`,
        complete: (data) => (data ? html`${unsafeHTML(data)}` : nothing),
      })}
    `
  }

  render() {
    return html`
      <dialog
        role="dialog"
        aria-modal="true"
        type="${this.type}"
        aria-labelledby="${this.id}-dialogTitle"
        @modal-close=${this.#handleClose}
        @close=${this.#handleClose}
        .inert=${!this.modalIsOpen}
        class="dialog"
        @click=${this._handleBackdropClick}
      >
        <div
          class="${this.type || 'modal'} ${
            this.dialogClasses
          } grid grid-cols-1 grid-rows-[var(--dmn-dialog-header-height,_64px)_minmax(0,_1fr)_auto]"
          size=${this.size}
          anchor=${this.anchor}
        >
          <div
            class="${
              this.headerClasses
            } drawer-header sticky top-0 z-50 flex items-center justify-between border-b border-t-border bg-p-lightest px-sm py-xs"
          >
            <div
              class="${this.withoutTitle ? 'sr-only' : ''} flex-grow"
              id="${this.id}-dialogTitle"
            >
              <slot name="header"></slot>
            </div>

            <button
              @click=${this.#handleClose}
              class="${
                this.closeIconPosition === 'right' ? 'ml-auto' : 'mr-auto'
              } inline-flex leading-none focus:outline-none focus-visible:ring-1 focus-visible:ring-u-focus"
            >
              <slot name="close-icon">
                <svg-icon
                  src="icon-close"
                  style="font-size: ${this.closeIconSize}px"
                ></svg-icon>
                <span class="sr-only">Close</span>
              </slot>
            </button>
          </div>
          <div class="drawer-content">${this.dialogContentHTML}</div>
        </div>
      </dialog>
    `
  }
}

customElements.define('modal-dialog', ModalDialog)
